import React from 'react';
import FormLinksContainer from './layout/FormLinksContainer/FormLinksContainer';
import Buttons from './Buttons/Buttons';
import Disclosures from './Disclosures/Disclosures';
import NonInputsContainer from './layout/NonInputsContainer/NonInputsContainer';
import Inputs from './Inputs/Inputs';
import SecurityLinks from './SecurityLinks/SecurityLinks';
import TermsLink from './TermsLink/TermsLink';
import AlreadyAMember from './AlreadyAMember/AlreadyAMember';
import { AddressValidationStateProvider } from '../../providers/AddressValidationProvider';
import Form from './layout/Form/Form';
import DisclaimerText from '../DisclaimerText/DisclaimerText';
import InlinePushup from '../../../../utils/utility-components/InlinePushup';
import usePushupMessages from '../../hooks/usePushupMessages';
import { Row, Col } from '../../../../importCL';
import './DataEntryForm.css';

interface IDataEntryFormProps {
    isInvalidAddressPopUpVariant: boolean;
    cityStateRetrievalEnabled: boolean;
    isSingleAddressField: boolean;
    isAddressLockVariant: boolean;
}

export default function DataEntryForm(props: IDataEntryFormProps) {
    return (
        <Row as='section' className='DataEntryForm mt-4'>
            <Col className='!px-10'>
                <AddressValidationStateProvider>
                    <Form>
                        <Inputs
                            isInvalidAddressPopUpVariant={props.isInvalidAddressPopUpVariant}
                            cityStateRetrievalEnabled={props.cityStateRetrievalEnabled}
                            isSingleAddressField={props.isSingleAddressField}
                            isAddressLockVariant={props.isAddressLockVariant}
                        />
                        <NonInputsContainer>
                            <Disclosures />
                            <InlinePushup messages={usePushupMessages().messages} />
                            <Buttons />
                        </NonInputsContainer>
                        <FormLinksContainer>
                            <SecurityLinks />
                            <TermsLink />
                        </FormLinksContainer>
                    </Form>
                </AddressValidationStateProvider>
                <DisclaimerText />
                <div className='DataEntryForm__member_button mx-auto'>
                    <AlreadyAMember />
                </div>
            </Col>
        </Row >
    );
}
